
import ShaderService from "../../../lib/services/shader/shader_service";
import PlaneRenderPipeline from "../../../lib/services/render/pipelines/plane_renderpipeline";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";
import SceneObject from "../../../lib/services/scene/sceneobject";
import Papercloud from "./papercloud";
import DioramaRenderPipelineInstanced from "../../../lib/services/render/pipelines/diorama_renderpipeline_instanced";
import Transform from "../../../lib/services/render/transform";
import PlaceTransform from "../../../lib/services/scene/place_transform";
const MOVE_Z = -5.0;//-3.1;

export default class Sky extends SceneObject 
{


    cloud_panels: Papercloud[] = [];
    sky_inst:DioramaRenderPipelineInstanced;
    far_mountain_inst:DioramaRenderPipelineInstanced;
    near_mountain_inst:DioramaRenderPipelineInstanced;
    cloud_inst:DioramaRenderPipelineInstanced;
    birds_inst:DioramaRenderPipelineInstanced;
    distant_forest_inst:DioramaRenderPipelineInstanced;
    near_forest_inst:DioramaRenderPipelineInstanced;
    
    place_t:PlaceTransform;


  constructor(key: string) 
  {
     super(key);

     const si= 0;
     this.place_t= new PlaceTransform("nf"+si,this.transform);
     this.sky_inst = this.make_sky_panels();
     this.far_mountain_inst = this.make_far_mountain_panels();
     this.near_mountain_inst = this.make_near_mountain_panels();
     this.cloud_inst = this.make_cloud_panels();
     this.birds_inst = this.make_birds_panels();
     this.distant_forest_inst = this.make_distant_forest_panels();
     this.near_forest_inst = this.make_near_forest_panels();

     this.place_t.set_transform(this.near_forest_inst.transforms[si]);   

 }

  async build(device: GPUDevice, format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
        this.sky_inst.build(device,format,shader_service,resource_service);
        this.far_mountain_inst.build(device,format,shader_service,resource_service);
        this.near_mountain_inst.build(device,format,shader_service,resource_service);
        this.cloud_inst.build(device,format,shader_service,resource_service);
        this.birds_inst.build(device,format,shader_service,resource_service);
        this.distant_forest_inst.build(device,format,shader_service,resource_service);
        this.near_forest_inst.build(device,format,shader_service,resource_service);
        
        super.build(device,format,shader_service,resource_service);
  }

  make_transform(x:number,y:number,z:number,sx:number,sy:number,sz:number):Transform
  {
      const t = new Transform();
      t.set_position(x,y,z);
      t.set_rotation(0, 0, 0);
      t.set_scale(sx,sy,sz);
      t.update_matrix();
      return t;
  }
  
  make_sky_panels():DioramaRenderPipelineInstanced
  {
     //1536x1024
     const width = 3;
     const height = 2;
     const y = 0.5;
     const s = 1.75;
     const z = -7.5+MOVE_Z
     var transforms:Transform[] =[];
     transforms.push(this.make_transform(-19.754775047302246,y,z,-s,s,s));
     transforms.push(this.make_transform(-14.754775047302246,y,z,s,s,s));
     transforms.push(this.make_transform(-9.971558570861816,y,z,-s,s,s));
     transforms.push(this.make_transform(-5.056499004364014,y,z,s,s,s));
     transforms.push(this.make_transform(0,y,z,-s,s,s));
     transforms.push(this.make_transform(5.169861316680908,y,z,s,s,s));
     transforms.push(this.make_transform(10.4,y,z,-s,s,s));
     transforms.push(this.make_transform(15.643829345703125,y,z,s,s,s));

      const drp= new DioramaRenderPipelineInstanced("sky","unlit_texture_alpha_instanced","sky_only",width,height,transforms);
      return drp;
  }

  make_far_mountain_panels():DioramaRenderPipelineInstanced
  {
     const width = 2;
     const height = 1;
     var transforms:Transform[] =[];
     transforms.push(this.make_transform(-23.74359703063965,-0.6635398864746094,-7+MOVE_Z,-4.130654335021973,4.130654335021973,4.130654335021973));
     transforms.push(this.make_transform(-15.488879203796387,-0.6635398864746094,-7+MOVE_Z,4.130654335021973,4.130654335021973,4.130654335021973));
     transforms.push(this.make_transform(-7.890038013458252,-0.6635398864746094,-7+MOVE_Z,-4.130654335021973,4.130654335021973,4.130654335021973));
     transforms.push(this.make_transform(0,-0.6635398864746094,-7+MOVE_Z,4.130654335021973,4.130654335021973,4.130654335021973));
     transforms.push(this.make_transform(8.18673324584961,-0.6635398864746094,-7+MOVE_Z,-4.130654335021973,4.130654335021973,4.130654335021973));
     transforms.push(this.make_transform(16.442256927490234,-0.6635398864746094,-7+MOVE_Z,4.130654335021973,4.130654335021973,4.130654335021973));

      const drp= new DioramaRenderPipelineInstanced("far_mountain","unlit_texture_alpha_instanced","far_mountain",width,height,transforms);
      return drp;
   
  }

  make_near_mountain_panels():DioramaRenderPipelineInstanced
  {
     const width = 2;
     const height = 1.3334;
     var transforms:Transform[] =[];
     const z =-9.826048851013184;
     const s = 2.8698949813842773;
     const y = -0.2
     transforms.push(this.make_transform(-17.457094192504883,y,z,-s,s,s));
     transforms.push(this.make_transform(-11.457094192504883,y,z,s,s,s));
     transforms.push(this.make_transform(-5.728638172149658,y,z,-s,s,s));
     transforms.push(this.make_transform( 0 ,y,z,s,s,s));
     transforms.push(this.make_transform( 5.730597496032715,y,z,-s,s,s));
     transforms.push(this.make_transform( 11.457094192504883,y,z,s,s,s));
    
      const drp= new DioramaRenderPipelineInstanced("near_mountain","unlit_texture_alpha_instanced","near_mountain",width,height,transforms);
      return drp;
   
  }

  make_cloud_panels():DioramaRenderPipelineInstanced
  {
     const width = 4;
     const height = 3;
     var transforms:Transform[] =[];
     const z =-9.0;
     
     transforms.push(this.make_transform(2.028409004211426,0.3134600818157196,z,0.7580538392066956,0.7580538392066956,0.7580538392066956));
     transforms.push(this.make_transform(0.9546302556991577,1.2804893255233765,z+0.3,0.5679671764373779,0.5679671764373779,0.5679671764373779));
     transforms.push(this.make_transform(-0.26428112387657166,0.8986893892288208,z+0.5,0.34833210706710815,0.34833210706710815,0.34833210706710815));
     transforms.push(this.make_transform( -2.757800817489624,0.7085193395614624,z,0.57988572120666,0.57988572120666,0.57988572120666));
    
      const drp= new DioramaRenderPipelineInstanced("clouds","unlit_texture_alpha_instanced","cloud0",width,height,transforms);
      return drp;
   
  }


  make_birds_panels():DioramaRenderPipelineInstanced
  {
     const width = 2;
     const height = 0.67;
     var transforms:Transform[] =[];
     const z =-8.5;
      transforms.push(this.make_transform(-2.0374481678009033,1.4339494705200195,z,1,1,1));
       transforms.push(this.make_transform(2.5492982864379883,1.0757497549057007,z,1,1,1));
      const drp= new DioramaRenderPipelineInstanced("birds","unlit_texture_alpha_instanced","birdstrip",width,height,transforms);
      return drp;
   
  }


  make_distant_forest_panels():DioramaRenderPipelineInstanced
  {
     const width = 2;
     const height = 0.67;
     var transforms:Transform[] =[];
     const z =-7;
     const y =0.255;
     const s = 2.07;
      transforms.push(this.make_transform(-16.60537910461425,y,z,s,s,s));
      transforms.push(this.make_transform(-12.421789169311523,y,z,-s,s,s));
      transforms.push(this.make_transform(-8.291744232177734,y,z,s,s,s));
      transforms.push(this.make_transform(-4.160102844238281,y,z,-s,s,s));
      transforms.push(this.make_transform(0,y,z,s,s,s));
      transforms.push(this.make_transform(4.160102844238281,y,z,-s,s,s));
      transforms.push(this.make_transform(8.291744232177734,y,z,s,s,s));
      transforms.push(this.make_transform(12.421789169311523,y,z,-s,s,s));
      const drp= new DioramaRenderPipelineInstanced("distant_forest","unlit_texture_alpha_instanced","distant_forest",width,height,transforms);
      return drp;
   
  }


  make_near_forest_panels():DioramaRenderPipelineInstanced
  {
     const width = 2;
     const height = 1.3334;
     var transforms:Transform[] =[];
     const z =-6;
     const y =0.255;
     const s = 2.07;
      transforms.push(this.make_transform(-16.441822052001953,y,z,s,s,s));
      transforms.push(this.make_transform(-12.421789169311523,y,z,-s,s,s));
      transforms.push(this.make_transform(-8.291744232177734,y,z,s,s,s));
      transforms.push(this.make_transform(-4.160102844238281,y,z,-s,s,s));
      transforms.push(this.make_transform(0,y,z,s,s,s));
      transforms.push(this.make_transform(4.160102844238281,y,z,-s,s,s));
      transforms.push(this.make_transform(8.291744232177734,y,z,s,s,s));
      transforms.push(this.make_transform(12.421789169311523,y,z,-s,s,s));
      const drp= new DioramaRenderPipelineInstanced("near_forest","unlit_texture_alpha_instanced","near_forest",width,height,transforms);
      return drp;
   
  }



  tick(delta_time: number): void 
  {
     super.tick(delta_time);
    // this.place_t.tick(delta_time);
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
     this.sky_inst.prepare(device,camera);
     this.far_mountain_inst.prepare(device,camera);
     this.near_mountain_inst.prepare(device,camera);
     this.cloud_inst.prepare(device,camera);
     this.birds_inst.prepare(device,camera);
     this.distant_forest_inst.prepare(device,camera);
     this.near_forest_inst.prepare(device,camera);
     super.prepare(device,camera);
  }

  draw(pass: GPURenderPassEncoder): void 
  {
     this.sky_inst.draw(pass);
     this.far_mountain_inst.draw(pass);
     this.near_mountain_inst.draw(pass);
     this.cloud_inst.draw(pass);
     this.birds_inst.draw(pass);
     this.distant_forest_inst.draw(pass);
     this.near_forest_inst.draw(pass);
     super.draw(pass);
  }
}